import axios from "axios";

export const bitrixApi = axios.create({
  baseURL: "https://medsystems.bitrix24.com.br",
});

const MAX_REQUESTS = 4;

const min = 5000;
const max = 6000;
const ms = Math.floor(Math.random() * (max - min + 1)) + min;
const DELAY_BETWEEN_REQUESTS_MS = ms;

const requestQueue = [];
let activeRequests = 0;
let lastRequestTime = 0;

const processQueue = () => {
  if (requestQueue.length > 0 && activeRequests < MAX_REQUESTS) {
    const now = Date.now();
    const timeSinceLast = now - lastRequestTime;
    const delay = Math.max(DELAY_BETWEEN_REQUESTS_MS - timeSinceLast, 0);

    const nextRequest = requestQueue.shift();
    if (nextRequest) {
      setTimeout(() => {
        activeRequests++;
        lastRequestTime = Date.now();
        nextRequest();
      }, delay);
    }
  }
};

bitrixApi.interceptors.request.use(
  (config) =>
    new Promise((resolve) => {
      const executeRequest = () => {
        resolve(config);
      };

      requestQueue.push(executeRequest);
      processQueue();
    }),
);

bitrixApi.interceptors.response.use(
  (response) => {
    activeRequests--;
    processQueue();
    return response;
  },
  (error) => {
    activeRequests--;
    processQueue();
    return Promise.reject(error);
  },
);

bitrixApi.interceptors.response.use(
  (response) => {
    activeRequests--;
    processQueue();
    return response;
  },
  (error) => {
    activeRequests--;
    processQueue();
    // Loga todos os erros do bitrixApi
    console.error("Erro BitrixApi:", error?.response?.data || error.message || error);
    return Promise.reject(error);
  },
);
